export const associations = [
  "Externo",
  "UEB",
  "UEP",
  "UEO",
  "LGS",
  "FNEL",
  "LEMO",
];
